import React from "react";

// Mint
const Mint = ({
  connectWallet,
  walletConnected,
  totalMinted,
  mintQuantity,
  setMintQuantity,
  whitelistSaleMint,
}) => {
  return (
    <React.Fragment>
      <main className="mint-page">
        <section className="hero">
          <div className="container">
            <h1>
              <span>\\</span> Whitelist Mint <span>//</span>
            </h1>

            <div className="mint-box">
              <div className="images">
                <img
                  src="../../images/pages/about/hero-img-4.gif"
                  alt=""
                />
                <img
                  src="../../images/pages/about/hero-img-5.gif"
                  alt=""
                />
                <img
                  src="../../images/pages/about/hero-img-6.gif"
                  alt=""
                />
                <img
                  src="../../images/pages/about/hero-img-7.gif"
                  alt=""
                />
                <img
                  src="../../images/pages/about/hero-img-8.gif"
                  alt=""
                />
              </div>

              <div className="mint-box-bottom">
                <div className="mint-box-bottom-left">
                  <div className="quantity-box">
                    <button
                      onClick={() => {
                        if (mintQuantity > 1) {
                          setMintQuantity(mintQuantity - 1);
                        }
                      }}
                    >
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.5 24.3C16.3643 24.3 19.1114 23.1621 21.1368 21.1368C23.1621 19.1114 24.3 16.3643 24.3 13.5C24.3 10.6357 23.1621 7.88864 21.1368 5.86325C19.1114 3.83785 16.3643 2.7 13.5 2.7C10.6357 2.7 7.88864 3.83785 5.86325 5.86325C3.83785 7.88864 2.7 10.6357 2.7 13.5C2.7 16.3643 3.83785 19.1114 5.86325 21.1368C7.88864 23.1621 10.6357 24.3 13.5 24.3ZM13.5 27C6.04395 27 0 20.9561 0 13.5C0 6.04395 6.04395 0 13.5 0C20.9561 0 27 6.04395 27 13.5C27 20.9561 20.9561 27 13.5 27ZM6.75 12.15H20.25C20.608 12.15 20.9514 12.2922 21.2046 12.5454C21.4578 12.7986 21.6 13.142 21.6 13.5C21.6 13.858 21.4578 14.2014 21.2046 14.4546C20.9514 14.7078 20.608 14.85 20.25 14.85H6.75C6.39196 14.85 6.04858 14.7078 5.79541 14.4546C5.54223 14.2014 5.4 13.858 5.4 13.5C5.4 13.142 5.54223 12.7986 5.79541 12.5454C6.04858 12.2922 6.39196 12.15 6.75 12.15Z"
                          fill="url(#paint0_linear_134_22)"
                        ></path>
                        <defs>
                          <linearGradient
                            id="paint0_linear_134_22"
                            x1="13.5"
                            y1="0"
                            x2="13.5"
                            y2="27"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#f4aa19"></stop>
                            <stop offset="1" stopColor="#f4aa19"></stop>
                          </linearGradient>
                        </defs>
                      </svg>
                    </button>

                    <p>
                      Total: {mintQuantity} <span>X 0 MATIC</span>
                    </p>

                    <button
                      onClick={() => {
                        if (mintQuantity < 5) {
                          setMintQuantity(mintQuantity + 1);
                        }
                      }}
                    >
                      <svg
                        width="27"
                        height="27"
                        viewBox="0 0 27 27"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.5 27C6.04395 27 0 20.9561 0 13.5C0 6.04395 6.04395 0 13.5 0C20.9561 0 27 6.04395 27 13.5C27 20.9561 20.9561 27 13.5 27ZM13.5 24.3C16.3643 24.3 19.1114 23.1621 21.1368 21.1368C23.1621 19.1114 24.3 16.3643 24.3 13.5C24.3 10.6357 23.1621 7.88864 21.1368 5.86325C19.1114 3.83785 16.3643 2.7 13.5 2.7C10.6357 2.7 7.88864 3.83785 5.86325 5.86325C3.83785 7.88864 2.7 10.6357 2.7 13.5C2.7 16.3643 3.83785 19.1114 5.86325 21.1368C7.88864 23.1621 10.6357 24.3 13.5 24.3ZM14.85 14.85V20.25C14.85 20.608 14.7078 20.9514 14.4546 21.2046C14.2014 21.4578 13.858 21.6 13.5 21.6C13.142 21.6 12.7986 21.4578 12.5454 21.2046C12.2922 20.9514 12.15 20.608 12.15 20.25V14.85H6.75C6.39196 14.85 6.04858 14.7078 5.79541 14.4546C5.54223 14.2014 5.4 13.858 5.4 13.5C5.4 13.142 5.54223 12.7986 5.79541 12.5454C6.04858 12.2922 6.39196 12.15 6.75 12.15H12.15V6.75C12.15 6.39196 12.2922 6.04858 12.5454 5.79541C12.7986 5.54223 13.142 5.4 13.5 5.4C13.858 5.4 14.2014 5.54223 14.4546 5.79541C14.7078 6.04858 14.85 6.39196 14.85 6.75V12.15H20.25C20.608 12.15 20.9514 12.2922 21.2046 12.5454C21.4578 12.7986 21.6 13.142 21.6 13.5C21.6 13.858 21.4578 14.2014 21.2046 14.4546C20.9514 14.7078 20.608 14.85 20.25 14.85H14.85Z"
                          fill="url(#paint0_linear_134_21)"
                        ></path>
                        <defs>
                          <linearGradient
                            id="paint0_linear_134_21"
                            x1="13.5"
                            y1="0"
                            x2="13.5"
                            y2="27"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#f4aa19"></stop>
                            <stop offset="1" stopColor="#f4aa19"></stop>
                          </linearGradient>
                        </defs>
                      </svg>
                    </button>
                  </div>

                  <p>Minted: {totalMinted}/10,000</p>
                </div>

                <div className="mint-box-bottom-right">
                  <button onClick={walletConnected ? null : connectWallet}>
                    {walletConnected ? "Mint Now!" : "Connect Wallet"}
                  </button>
                  <p>0 MATIC Each NFT</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <img
          src="../../images/body-bg-img-2.png"
          alt=""
          className="body-bg-img-1"
        />
      </main>
    </React.Fragment>
  );
};

// Export
export default Mint;
